import { util } from 'echarts/core';
import { type VennSeriesOption } from './type';
import Palette from './helper/Palette';
import { LABEL_KEYS } from './config';

export function parseRegionsColor(seriesOption: VennSeriesOption) {
  const palette = new Palette(seriesOption.dvColors);
  const { data } = seriesOption;
  data.forEach(dataItem => {
    const combIndices = (dataItem.__group as string[]).map(
      comb => comb.charCodeAt(0) - LABEL_KEYS[0].charCodeAt(0)
    );
    const blendColor = palette.blendColorArr(combIndices, 'multiply');
    util.merge(dataItem, { itemStyle: {} });
    dataItem.itemStyle.areaColor = blendColor;
    dataItem.itemStyle.color = blendColor;
    dataItem.__color = blendColor;
  });
}
